<template>
    <div class="kit-product__qtt">
        <label>{{ qtt }}</label>
        <div class="kit-product__qtt-nav">
            <button @click="qttNav('plus')">
                <i class="fas fa-caret-up"></i>
            </button>
            <button @click="qttNav('minus')">
                <i class="fas fa-caret-down"></i>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductQuantity',
        props: ['min', 'max', 'qtt'],
        data() {
            return {
                quantity: this.qtt ? this.qtt : 1
            }
        },
        watch: {
            qtt: function () {
                this.quantity = this.qtt;
            }
        },
        methods: {
            qttNav(direction) {
                if (direction === 'plus') {

                    if (this.max != -1 && this.max === this.qtt + 1) return;

                    this.quantity++;
                
                } else if (direction === 'minus') {
                    
                    if (this.min === this.qtt) return;

                    this.quantity--;
                }

                this.$emit('update', this.quantity);
            },
        }
    }
</script>

<style lang="scss">
        .kit {
            &-product {
                &__qtt {
                border-radius: 12px;
                border: 0.5px solid #D2D5DE;
                background: #F8F8F8;
                display: flex;
                font-size: 11px;
                font-weight: 500;
                line-height: 19.462px;
                height: 26px;
                overflow: hidden;
                width: 67px;

                label {
                    width: 43px;
                    padding: 4px 8px;
                }

                &-nav {
                    width: 23px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    border-left: 1px solid #D2D5DE;

                    button, i {
                        line-height: 10px;
                    }

                    button {
                        width: 100%;
                        height: 50%;
                        transition: all .3s ease-in-out;

                        &:hover {
                            background-color: #F97623;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
</style>